<template>
  <modal
    name="ConfirmationDialog"
    height="auto"
    :maxWidth="300"
    :adaptive="true"
    @opened="opened"
    @closed="closed"
    @before-open="beforeOpen"
    :draggable="!isMobileDevice"
    :reset="true"
    :style="{ 'z-index': 100000 }"
  >
    <div class="dialog">
      <div class="message-container">
        <div class="message" v-html="message"></div>
      </div>
      <button type="button" class="button red" @click="yes()">ДА</button>
      <button type="button" class="button green" @click="no()">НЕТ</button>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_CONFIRMATION_DIALOG } from "@/store/actions.type";
export default {
  name: "ConfirmationDialog",
  computed: {
    ...mapGetters(["isMobileDevice"])
  },
  data() {
    return {
      message: "",
      yesHandler: null,
      noHandler: null
    };
  },
  methods: {
    yes() {
      this.$store.commit(SET_CONFIRMATION_DIALOG, false);

      if (this.yesHandler) {
        this.yesHandler();
      }

      this.$modal.hide("ConfirmationDialog");
    },
    no() {
      if (this.noHandler) {
        this.noHandler();
      }
      this.$modal.hide("ConfirmationDialog");
    },
    closed() {
      this.$store.commit(SET_CONFIRMATION_DIALOG, false);
    },
    opened() {
      this.$store.commit(SET_CONFIRMATION_DIALOG, true);
    },
    beforeOpen(event) {
      this.message = event.params.message;
      this.yesHandler = event.params.yes;
      this.noHandler = event.params.no;
    }
  }
};
</script>

<style lang="postcss" scoped>
.dialog {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto;
  grid-template-areas:
    "message message"
    "yes     no";
}

.message-container {
  grid-area: message;
  padding: 0.5em;
}

.button {
  height: 3em;
  font-weight: bold;
  font-size: 1em;
}
.button.red {
  grid-area: yes;
}

.button.green {
  grid-area: no;
}
</style>
